'use client'

import type {
  TypeCardImageBlockFields,
  TypeCardImageItemFields,
  TypeNewsArticleFields,
} from '@lib/generated-types'
import { contentTypeBasePathMap } from '@lib/constants'
import { routeMapper } from '@lib/menu-item-mapper'
import { pyMap, containerSizeMap, cardsPerRowMap, imageViewportWidthMap } from '@lib/token-maps'
import slugify from 'slugify'
import { CardImageBlock,CardImage } from '@shc/ui'
import Analytics from '@components/analytics'
import NextImage from '@components/next-image'
import getImageSizes from '@helpers/getImageSizes'

interface Fields {
  image: any
  title: string
  summary: string
}

const CardBlock = ({
  sectionLink,
  cards,
  width,
  columnsMax,
  paddingTop,
  paddingBottom,
  cardAlignment,
  blockAlignment,
}: TypeCardImageBlockFields) => {

  return (
    <CardImageBlock   
      id={typeof sectionLink === 'undefined' ? undefined : slugify(sectionLink)}  
      cardAlignment={cardAlignment}
      cardsPerRow={cardsPerRowMap[columnsMax]}
      containerAlignment={blockAlignment}
      containerSize={containerSizeMap[width]}
      paddingBottom={pyMap[paddingBottom]}
      paddingTop={pyMap[paddingTop]}>
      { cards.map(({ fields, sys }) => {
        const contentType = sys.contentType.sys.id
        let link: string, linkIsInternal: boolean
        if (contentType === 'cardImageItem') {
          const cardFields = fields as TypeCardImageItemFields
          const { route, isInternal } = routeMapper(
            cardFields.link,
            cardFields.anchorOrExternalLink
          )
          link = route
          linkIsInternal = isInternal || false
        } else {
          const newsFields = fields as TypeNewsArticleFields
          link = contentTypeBasePathMap[contentType] + newsFields.slug
          linkIsInternal = true
        }

        const dataFields = fields as Fields
        // Only render the Card if it has an image
        if (dataFields.image) {
          const imageDimensions = dataFields.image.fields.image.fields.file.details.image

          return (
            <Analytics
              key={sys.id}
              click={{
                name: 'component_click',
                data: {},
              }}
              contexts={[
                {
                  name: 'component',
                  data: {
                    component_text: dataFields.title,
                    component_url: link,
                  },
                },
                {
                  name: 'content',
                  data: {
                    content_type: sys.contentType.sys.id,
                    content_entry_id: sys.id,
                    content_level: 'item',
                    content_internal_name: dataFields.title,
                  },
                },
              ]}>
              <CardImage
                key={`card-image-${sys.id}`}
                heading={dataFields.title}
                description={dataFields.summary}
                href={link}
                target={linkIsInternal ? undefined : '_blank'}
                slots={{
                  image: NextImage
                }}
                slotProps={{
                  image: {
                    className: 'object-top',
                    src: dataFields.image.fields.image.fields.file.url,
                    sizes: getImageSizes('100vw', '50vw', '50vw', imageViewportWidthMap[columnsMax], imageViewportWidthMap[columnsMax], imageViewportWidthMap[columnsMax]),
                    alt: dataFields.title,
                    height: imageDimensions.height,
                    width: imageDimensions.width,
                  }
                }}
              />
            </Analytics>
          )
        }
      })}
    </CardImageBlock>
  )
}

export default CardBlock
